"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiCheckbox = getMuiCheckbox;
function getMuiCheckbox() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '&.Mui-checked': {
            '&.Mui-readOnly': {
              '.MuiSvgIcon-root': {
                backgroundColor: theme.palette.gray[25],
                borderColor: theme.palette.gray[100],
                color: theme.palette.gray[900]
              },
              cursor: 'default',
              pointerEvents: 'none'
            },
            '&:hover': {
              '.MuiSvgIcon-root': {
                backgroundColor: theme.palette.blue[100],
                border: 'solid',
                borderColor: theme.palette.blue[600],
                borderWidth: 1
              },
              background: 'none'
            },
            '.MuiSvgIcon-fontSizeSmall': {
              borderRadius: 4,
              borderWidth: 1,
              boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
              height: 16,
              width: 16
            },
            '.MuiSvgIcon-root': {
              backgroundColor: theme.palette.primary[50],
              border: 'solid',
              borderColor: theme.palette.blue[600],
              borderRadius: 6,
              borderWidth: 1,
              height: 20,
              padding: '2px',
              width: 20
            }
          },
          '&.Mui-disabled': {
            '.MuiSvgIcon-root': {
              backgroundColor: theme.palette.gray[100],
              border: "1px solid ".concat(theme.palette.gray[300])
            }
          },
          '&.Mui-readOnly': {
            '.MuiSvgIcon-root': {
              backgroundColor: theme.palette.gray[25],
              borderColor: theme.palette.gray[100]
            },
            cursor: 'default',
            pointerEvents: 'none'
          },
          '&.MuiCheckbox-indeterminate': {
            '&.Mui-readOnly': {
              '.MuiSvgIcon-root': {
                backgroundColor: theme.palette.gray[25],
                borderColor: theme.palette.gray[100],
                color: theme.palette.gray[900]
              }
            },
            '.MuiSvgIcon-root': {
              border: "1px solid ".concat(theme.palette.primary[600]),
              borderRadius: '4px',
              padding: '2px'
            }
          },
          '&:focus-within': {
            borderRadius: 6,
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.primary[100]),
            height: 'inherit',
            width: 'inherit'
          },
          '&:hover': {
            '.MuiSvgIcon-root': {
              backgroundColor: theme.palette.primary[100],
              border: 'solid',
              borderColor: theme.palette.primary[600],
              borderWidth: 1
            },
            background: 'none'
          },
          '.MuiSvgIcon-fontSizeSmall': {
            borderColor: theme.palette.gray[400],
            borderRadius: '4px !important',
            borderStyle: 'solid',
            borderWidth: 1,
            height: '16px !important',
            width: '16px !important'
          },
          '.MuiSvgIcon-root': {
            borderColor: theme.palette.gray[400],
            borderRadius: 6,
            borderStyle: 'solid',
            borderWidth: 1,
            height: 20,
            width: 20
          },
          padding: 0
        };
      }
    }
  };
}